import React, { createContext } from "react";

type UserType = "member" | "lapsedmember" | "non-member";

export type UserContextType = {
  type: UserType;
  isLoggedIn: boolean;
  isMember: boolean;
};

export const UserContext = createContext({} as UserContextType);

export const UserProvider: React.FC<{
  children: React.ReactNode;
  type: UserType;
}> = ({ children, type }) => {
  const isLoggedIn = ["member", "lapsedmember"].includes(type);
  const isMember = type === "member";

  return (
    <UserContext.Provider value={{ type, isLoggedIn, isMember }}>
      {children}
    </UserContext.Provider>
  );
};
